export const MAX_EXAM_SCHEDULE_DAYS = 60;

